module.exports = __webpack_public_path__ + "static/restaurant-9ae8003744830445e9c4a04166228dc6.jpg";